import React, { useContext, useMemo } from 'react';
import { useGlobalEnvConfig } from "@environment/GlobalEnvConfigProvider";
import { BasicData } from '@App';
import { safeImageUrl, getColor } from '@utils/Utils';

import './style.scss';

const NavBarTop = () => {
    const { REACT_APP_RESOURCE_DOMAIN } = useGlobalEnvConfig();
    const { branding, theme } = useContext(BasicData);
    const colors = getColor(theme);

    const hideLogo = useMemo(() => theme?.logo_size === 'Hide' || !branding, [theme, branding])

    const logoSize = useMemo(() => {
        return {
            'Small': { width: '150', height: '75' },
            'Medium': { width: '200', height: '100' },
            'Large': { width: '300', height: '150' }
        }[theme?.logo_size] || { width: '150', height: '75' }
    }, [theme])

    const logo = useMemo(() => {
        return branding?.logo_url_fragment ? safeImageUrl(REACT_APP_RESOURCE_DOMAIN, branding.logo_url_fragment, 2500, 2500, "", "?fmt=png") : null;
    }, [branding, logoSize, REACT_APP_RESOURCE_DOMAIN])

    if (hideLogo) {
        return <></>
    }

    return (
        <div
            className={`nav-bar-top ${branding?.is_cobranded ? "co-branded" : ""} ${theme?.logo_size ? theme.logo_size.toLowerCase() : 'small'}`}
            id='nav-bar-top'
            style={{
                backgroundColor: colors?.navigation_bar_color
                    ? `#${colors?.navigation_bar_color}`
                    : `#${colors?.secondary}`
            }}
        >
            {logo && (
                <a href={branding?.website}>
                    <img
                        src={logo}
                        alt=""
                        width={logoSize.width}
                        height={logoSize.height}
                    />
                </a>
            )}
        </div>
    )
}

export default React.memo(NavBarTop);